import { LoggedUser } from '../../session/session-decode';
import { isDistributor, isIntegrator } from '../../session/user-type';

/**
 * Destino do clique no logo. Espelha `SidebarComponent.redirecionar`:
 * `/conta/list-conta` para integrador sem tenant, `/integrador/list-integrador`
 * para quem não é integrador e não tem contas, `/home` nos demais casos com
 * usuário presente, e `null` (sem navegação) quando não há usuário.
 */
export function resolveLogoRedirect(user: LoggedUser | null, possuiTenant: boolean): string | null {
  if (!user) {
    return null;
  }

  if (isIntegrator(user) && !possuiTenant) {
    return '/conta/list-conta';
  }

  if (!isIntegrator(user) && isDistributor(user)) {
    return '/integrador/list-integrador';
  }

  return '/home';
}
